import type { ReactNode } from "react";
import React, { useState } from "react";
import { MENU_BUTTON } from "@/components/game/menu/MenuLayout.js";
import { Button } from "@rosette/web_components/src/ui/Button.js";


interface ConfirmButtonProps {
    children?: ReactNode;
    tone?: "neutral" | "danger";
    onSubmit: () => void;
    skipConfirm?: boolean;
}


/**
 * A menu button that asks "Are you sure?" on its first click, and acts
 * on the second.
 */
export function ConfirmButton({
    children, tone, onSubmit, skipConfirm,
}: ConfirmButtonProps) {
    const [showConfirm, setShowConfirm] = useState(false);
    return (
        <Button
            tone={tone}
            size="lg"
            className={MENU_BUTTON}
            onClick={() => {
                if (showConfirm || skipConfirm) {
                    onSubmit();
                } else {
                    setShowConfirm(true);
                }
            }}>

            {showConfirm ? "Are you sure?" : children}
        </Button>
    );
}
